var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.0013 1.94807C5.10699 1.94807 1.95002 5.10503 1.95002 8.99935C1.95002 12.8937 5.10699 16.0506 9.0013 16.0506C12.8956 16.0506 16.0526 12.8937 16.0526 8.99935C16.0526 5.10503 12.8956 1.94807 9.0013 1.94807ZM0.667969 8.99935C0.667969 4.39698 4.39893 0.666016 9.0013 0.666016C13.6037 0.666016 17.3346 4.39698 17.3346 8.99935C17.3346 13.6017 13.6037 17.3327 9.0013 17.3327C4.39893 17.3327 0.667969 13.6017 0.667969 8.99935Z",
    fill: "#8D8D8D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00134 4.08482C9.35536 4.08482 9.64236 4.37182 9.64236 4.72584V8.99935C9.64236 9.16936 9.57483 9.33241 9.45461 9.45262L6.89049 12.0167C6.64015 12.2671 6.23428 12.2671 5.98394 12.0167C5.73361 11.7664 5.73361 11.3605 5.98395 11.1102L8.36031 8.73383V4.72584C8.36031 4.37182 8.64731 4.08482 9.00134 4.08482Z",
    fill: "#8D8D8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/ClockIcon.1e8f4d5173f40ec37c2667aa6025d985.svg";
export { ForwardRef as ReactComponent };